import Button from '@alltrails/shared/denali/components/Button';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import CustomProvider from 'components/CustomProvider';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import * as styles from './connectButtonStyles.module.scss';

const createReactClass = require('create-react-class');

const BaseConnectAppleButton = createReactClass({
  componentDidMount() {
    ServerCommunicationUtil.initApple(this.props.authState);
  },
  handleUnlinkClick() {
    ServerCommunicationUtil.postApiEndpoint(this.props.unlinkPath, {});
  },
  render() {
    let button;
    if (this.props.appleSigninId) {
      button = (
        <li className="mark no-underline">
          <form id="connect-apple-form" className={styles.connectButton} onSubmit={this.handleUnlinkClick}>
            <FormattedMessage defaultMessage="Connected" />
            <Button text={<FormattedMessage defaultMessage="Unlink" />} type="submit" size="sm" variant="destructive" />
          </form>
        </li>
      );
    } else {
      button = (
        <a className="account-settings flat-apple-btn apple" data-testid="connect-with-apple">
          <div>
            <span>
              <FormattedMessage defaultMessage="Connect with Apple" />
            </span>
          </div>
        </a>
      );
    }
    return <ul className="sidebar-header">{button}</ul>;
  }
});

const ConnectAppleButton = props => {
  return (
    <CustomProvider>
      <BaseConnectAppleButton {...props} />
    </CustomProvider>
  );
};

export { ConnectAppleButton };
